var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9763 26.3497L38.3106 30.5436L25.4981 42.9615H21.1427V38.7472L33.9763 26.3497ZM38.1415 22.7696C38.4375 22.7696 38.7123 22.8923 38.9449 23.1174L41.6511 25.736C42.1163 26.1656 42.1163 26.8816 41.6511 27.3112L39.5369 29.357L35.2026 25.1632L37.3169 23.1174C37.5495 22.8923 37.8455 22.7696 38.1415 22.7696ZM38.0569 14.3205H25.3713V28.641L21.1427 32.7326V28.641H16.9142V40.9157H12.6856V14.3205H0V10.2289H38.0569V14.3205ZM19.0284 0C21.3541 0 23.257 1.84121 23.257 4.09157C23.257 6.34193 21.3541 8.18314 19.0284 8.18314C16.7027 8.18314 14.7999 6.34193 14.7999 4.09157C14.7999 1.84121 16.7027 0 19.0284 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.52a27ca8c7649f1b6caf5fa16fcdfbe6.svg";
export { ForwardRef as ReactComponent };